export const exportType = {
    CSV: 'csv',
    XLSX: 'xlsx',
}
